import Model, { attr, hasMany } from '@warp-drive/legacy/model';
import { Type } from '@warp-drive/core-types/symbols';
import type PcsMerchantNetworkMerchantModel from './pcs-merchant-network-merchant.ts';
import type PcsNetworkMerchantDetailModel from './pcs-network-merchant-detail.ts';

export default class PcsNetworkMerchantModel extends Model {
  @attr declare network: string;
  @attr declare networkId: string;

  /*************************
   **  Relationships      **
   *************************/

  @hasMany('pcs-merchant-network-merchant', { async: false, inverse: 'pcsNetworkMerchant' })
  declare pcsMerchantNetworkMerchants: PcsMerchantNetworkMerchantModel[];

  @hasMany('pcs-network-merchant-detail', { async: false, inverse: 'pcsNetworkMerchant' })
  declare pcsNetworkMerchantDetails: PcsNetworkMerchantDetailModel[];

  [Type] = 'pcs-network-merchant' as const;
}
